import { useUISettings } from '../../context/network/http/QueryProvider/queries/UISettings';
import { setLanguage, addTranslations } from './localizationService';
import { useEffect, useMemo } from 'react';
import en from './locales/en.json';

export function useSyncTranslations() {
    const { data } = useUISettings();
    const locale = useMemo(() => {
        if (data?.locale) {
            try {
                return JSON.parse(data.locale);
            } catch (error) {
                console.error('Error parsing locale JSON:', error);
            }
        }
        return { Name: 'en-us', ...en };
    }, [data?.locale]);

    // Change language only when necessary
    useEffect(() => {
        const { Name, ...translations } = locale;
        if (Name) {
            addTranslations(Name, translations);
            setLanguage(Name);
        }
    }, [locale]);
}
